"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.realtime = exports.requestRealtimeActivation = exports.getRealtimeLogs = void 0;
const createApi_1 = require("../../helpers/createApi");
const getRealtimeLogs = (caller) => ({ clientId, testId }) => {
    const url = `/clients/${clientId}/campaigns/${testId}/report`;
    return caller(url).get();
};
exports.getRealtimeLogs = getRealtimeLogs;
const requestRealtimeActivation = (caller) => ({ clientId, testId }) => {
    const url = `/clients/${clientId}/campaigns/${testId}/report`;
    return caller(url).post();
};
exports.requestRealtimeActivation = requestRealtimeActivation;
exports.realtime = (0, createApi_1.createAPIFactory)({
    getRealtimeLogs: exports.getRealtimeLogs,
    requestRealtimeActivation: exports.requestRealtimeActivation,
});
//# sourceMappingURL=realtime.js.map